export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ServicioSocialPage.vue?vue&type=template&id=2afb725c&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/ServicioSocialPage.vue?vue&type=template&id=2afb725c&scoped=true&
// module id = 644
// module chunks = 11